@if (open()) {
  <div class="drawer-overlay" (click)="close()">
    <div class="drawer-panel" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="drawer-header">
        <h2 class="drawer-title">
          <i class="bi bi-person-gear drawer-title-icon"></i>
          Edit Account
        </h2>
        <button class="drawer-close" (click)="close()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Loading -->
      @if (loading()) {
        <div class="drawer-loading">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      }

      <!-- Content -->
      @if (!loading() && profile(); as p) {
        <div class="drawer-body">
          <!-- Profile Section -->
          <div class="drawer-section">
            <div class="section-header">
              <h3 class="section-title">
                <i class="bi bi-person section-icon"></i>
                Profile
              </h3>
              @if (!editing()) {
                <button class="btn-section-action" (click)="startEdit()">
                  <i class="bi bi-pencil"></i> Edit
                </button>
              }
            </div>

            @if (!editing()) {
              <!-- View mode -->
              <div class="profile-info">
                <div class="info-row">
                  <span class="info-label">Username</span>
                  <span class="info-value">{{ p.username }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Display Name</span>
                  <span class="info-value">{{ p.displayName ?? '—' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Email</span>
                  <span class="info-value">{{ p.email ?? '—' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Status</span>
                  <span class="info-value">
                    <span [ngClass]="statusClass(p.accountStatus)">{{ p.accountStatus }}</span>
                  </span>
                </div>
                <div class="info-row">
                  <span class="info-label">Last Login</span>
                  <span class="info-value muted">{{ formatDate(p.lastLoginDatetime) }}</span>
                </div>
              </div>
            } @else {
              <!-- Edit mode -->
              <div class="edit-form">
                <div class="form-group">
                  <label class="form-label" for="ea-displayName">Display Name</label>
                  <input id="ea-displayName" type="text" class="form-input" [(ngModel)]="editDisplayName" />
                </div>
                <div class="form-group">
                  <label class="form-label" for="ea-email">Email</label>
                  <input id="ea-email" type="email" class="form-input" [(ngModel)]="editEmail" />
                </div>
                <div class="form-actions">
                  <button class="btn-cancel" (click)="cancelEdit()">Cancel</button>
                  <button class="btn-save" [disabled]="saving()" (click)="saveProfile()">
                    @if (saving()) {
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    }
                    Save Changes
                  </button>
                </div>
              </div>
            }
          </div>

          <!-- Divider -->
          <div class="section-divider"></div>

          <!-- Change Password Section -->
          <div class="drawer-section">
            <div class="section-header">
              <h3 class="section-title">
                <i class="bi bi-shield-lock section-icon"></i>
                Security
              </h3>
            </div>

            @if (!showPasswordForm()) {
              <div class="action-row">
                <div class="action-desc">
                  <span class="action-label">Change Password</span>
                  <span class="action-hint">Update your account password</span>
                </div>
                <button class="btn-section-action" (click)="showPasswordForm.set(true)">
                  <i class="bi bi-key"></i> Change
                </button>
              </div>
            } @else {
              <div class="edit-form password-form">
                <div class="form-group">
                  <label class="form-label" for="ea-current-pw">Current Password</label>
                  <input id="ea-current-pw" type="password" class="form-input" [(ngModel)]="currentPassword" />
                </div>
                <div class="form-group">
                  <label class="form-label" for="ea-new-pw">New Password</label>
                  <input id="ea-new-pw" type="password" class="form-input" [(ngModel)]="newPassword" />
                </div>
                <div class="form-group">
                  <label class="form-label" for="ea-confirm-pw">Confirm New Password</label>
                  <input id="ea-confirm-pw" type="password" class="form-input" [(ngModel)]="confirmPassword" />
                </div>
                <div class="form-actions">
                  <button class="btn-cancel" (click)="cancelPasswordChange()">Cancel</button>
                  <button class="btn-save" [disabled]="changingPassword()" (click)="submitPasswordChange()">
                    @if (changingPassword()) {
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    }
                    Change Password
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
